import React from "react";

export default function PlanList(){
    return(
        <img src={ require('../image/套餐要求.png').default } />
    )
}